(function () {
  'use strict';

  angular.module('bitrix24', []);
})();
